module.exports = __webpack_public_path__ + "img/logo-w.d2eb919d.png";